var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2979 2.63025H19.6715V17.6763H11.2979V2.63025Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8295 10.1533C11.8295 7.09628 13.265 4.38475 15.4713 2.63022C13.8499 1.35426 11.803 0.583374 9.57004 0.583374C4.27982 0.583374 0 4.86319 0 10.1533C0 15.4433 4.27982 19.7232 9.56992 19.7232C11.8029 19.7232 13.8497 18.9523 15.4713 17.6762C13.265 15.9484 11.8295 13.2103 11.8295 10.1533Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9694 10.1533C30.9694 15.4433 26.6895 19.7232 21.3994 19.7232C19.1665 19.7232 17.1196 18.9523 15.498 17.6762C17.731 15.9218 19.1399 13.2103 19.1399 10.1533C19.1399 7.09628 17.7044 4.38475 15.498 2.63022C17.1195 1.35426 19.1665 0.583374 21.3994 0.583374C26.6895 0.583374 30.9695 4.88983 30.9695 10.1533H30.9694Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.2d68f4e5874c41ad1266e8375093e6b7.svg";
export { ForwardRef as ReactComponent };